import { useQuery } from "@tanstack/react-query";
import { getLevel } from "../../api/apiLevels";
import i18next from "i18next";

export function useGetLevel(id) {
    const { isLoading, data: level, error } = useQuery({
        queryKey: ["levels", id, i18next.language],
        queryFn: () => getLevel(id),
        enabled: !!id,
        retry: false,
    });

    return { isLoading, error, level };
}
